import {CheckCircle} from '@mui/icons-material';
import {Box, List, ListItem, ListItemButton, Paper, Typography} from '@mui/material';

export interface TableOfContentsItem {
  id: string;
  title: string;
  index: number;
  completed?: boolean;
}

export interface StudyPageTableOfContentsProps {
  items: TableOfContentsItem[];
  currentIndex: number;
  onItemClick: (index: number) => void;
  subjectColor: {bg: string; border: string};
}

export default function StudyPageTableOfContents({
  items,
  currentIndex,
  onItemClick,
  subjectColor,
}: StudyPageTableOfContentsProps) {
  return (
    <Box sx={{width: 250, flexShrink: 0}} data-testid="study-page-table-of-contents">
      <Paper
        sx={{
          p: 2,
          bgcolor: 'white',
          borderRadius: 2,
          boxShadow: 1,
          position: 'sticky',
          top: 20,
          maxHeight: 'calc(100vh - 100px)',
          overflow: 'auto',
        }}
      >
        <Typography variant="h6" sx={{fontWeight: 600, mb: 2}}>
          Table of Contents
        </Typography>
        <List dense>
          {items.map((item) => (
            <ListItem key={item.id} disablePadding>
              <ListItemButton
                selected={item.index === currentIndex}
                onClick={() => onItemClick(item.index)}
                sx={{
                  borderRadius: 1,
                  '&.Mui-selected': {
                    bgcolor: `${subjectColor.bg}`,
                    color: subjectColor.border,
                    fontWeight: 600,
                    '&:hover': {
                      bgcolor: `${subjectColor.bg}`,
                    },
                  },
                  ...(item.completed &&
                    !(item.index === currentIndex) && {
                      color: 'success.main',
                      '&:hover': {
                        bgcolor: 'success.light',
                        opacity: 0.8,
                      },
                    }),
                }}
                data-testid={`study-page-toc-item-${item.index}`}
              >
                {item.completed && <CheckCircle sx={{fontSize: '0.875rem', mr: 1}} />}
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: '0.875rem',
                    ...(item.completed && {
                      fontWeight: 500,
                    }),
                  }}
                >
                  {item.title}
                </Typography>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Paper>
    </Box>
  );
}
